import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getClients } from "../helpers/Clients";
import { Link } from "react-router-dom";
import { getVendors } from "../helpers/Vendors";
import { getUsers } from "../helpers/Users";


export default function Users() {
    const { appState } = useAppState();
    const [users, setUsers] = useState<Array<any>>([])

    useEffect(() => {
        getUsers().then((result) => {
            setUsers(result)
        })
    }, [])

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Users</h1>
                <Link to="/users/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create user</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                            <th className="p-2">Email</th>
                            <th className="p-2">Vendor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">{user.id}</td>
                                    <td className="p-2">{user.name}</td>
                                    <td className="p-2">{user.email}</td>
                                    <td className="p-2">{user.vendor.name}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
}
